/**
 * Stack routes of the native screens added by the `marketing` admin-module group.
 * Registered by AppNavigator in the management stack.
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    {name: 'MarketingCampaignsScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/MarketingCampaignsScreen'))},
    {name: 'MarketingCampaignDetailScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/MarketingCampaignDetailScreen'))},
    {name: 'LoyaltyDashboardScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/LoyaltyDashboardScreen'))},
    {name: 'LoyaltyMembersScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/LoyaltyMembersScreen'))},
    {name: 'MarketingResourceScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/MarketingResourceScreen'))},
    {name: 'MarketingResourceDetailScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/MarketingResourceDetailScreen'))},
    {name: 'MarketingDashboardScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/MarketingDashboardScreen'))},
    {name: 'LoyaltySettingsScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/LoyaltySettingsScreen'))},
    {name: 'LoyaltyTerminalScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/LoyaltyTerminalScreen'))},
    {name: 'DesktopAppsScreen', component: lazyScreen(() => import('../../screens/adminModules/marketing/DesktopAppsScreen'))},
];

export default ROUTES;
